import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { EventSummary, EventSummaryEntry } from "@models/event-summary";
import { SkeletonModule } from "primeng/skeleton";

export interface SellerTotal {
  value: number;
  quantity: number;
}

@Component({
  selector: "app-report-overview",
  imports: [CommonModule, SkeletonModule],
  templateUrl: "./report-overview.component.html",
  styleUrl: "./report-overview.component.scss",
})
export class ReportOverviewComponent {
  @Input() summary: EventSummary | null = null;
  @Input() sellerTotal: SellerTotal | null = null;

  get totalValueWithoutCancelled() {
    if (this.summary)
      return (
        Number(this.summary.total.value) - Number(this.summary.cancelled.value)
      );
    return 0;
  }
  get totalQuantityWithoutCancelled() {
    if (this.summary)
      return this.summary.total.quantity - this.summary.cancelled.quantity;
    return 0;
  }

  get couponDiscountValue(): number {
    if (!this.summary) return 0;
    return Number(
      this.summary.coupon_discounts?.value ??
        this.summary.valid_sales.discount_value ??
        0,
    );
  }

  get couponDiscountQuantity(): number {
    return this.summary?.coupon_discounts?.quantity ?? 0;
  }

  salesProductionValue(entry: EventSummaryEntry): number {
    return Number(entry.gross_value ?? entry.value);
  }

  get pdvSalesValue(): number | null {
    const sales = this.summary?.pdv_sales;
    return sales ? Number(sales.value) : null;
  }

  get pdvSalesQuantity(): number | null {
    return this.summary?.pdv_sales?.quantity ?? null;
  }
}
